export default {
  data () {
    return {
      specialCharsTextarea: null
    }
  },
  methods: {
    convertChars (html) {
      if (!this.specialCharsTextarea) {
        this.specialCharsTextarea = document.createElement('textarea')
      }
      this.specialCharsTextarea.innerHTML = html
      return this.specialCharsTextarea.value
    }
  },
}
